"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _get = _interopRequireDefault(require("transmute/get"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var formatTeamId = function formatTeamId(team) {
  return String(team.id);
};

var formatTeamReference = function formatTeamReference(team) {
  return new _ReferenceRecord.default({
    id: formatTeamId(team),
    label: team.name,
    referencedObject: (0, _immutable.fromJS)(team)
  });
};

var formatTeams = function formatTeams(teams) {
  return (0, _indexBy.default)((0, _get.default)('id'), (0, _immutable.List)(teams).map(formatTeamReference));
};

var _default = formatTeams;
exports.default = _default;
module.exports = exports.default;